/**
 * 素材统计页文案
 */
import React from 'react';
import { TipsMapType } from '../index';

export const adsOverviewHeadText: TipsMapType = {
  en: (
    <>
      Data update frequency: Daily.
      <br />
      <br />
      The data on this page (such as creative count, material count, engagement, etc.)
      are not realtime data and may have a delay of 1-2 days.
    </>
  ),
  zh: (
    <>
      数据更新频率：每日更新。
      <br />
      <br />
      本页数据（如创意数、素材数、互动量等）非实时数据，可能存在 1-2 天的延迟。
    </>
  ),
};

// D1. 在投广告累计热度估值 Top10 渠道
export const adsChannelHeatScoreTips: TipsMapType = {
  en: (
    <>
      The sum of lifetime heat for currently active ads, not the daily increment.
    </>
  ),
  zh: (
    <>
      在投广告投放至今累计热度的加总，非当日累计增量。
    </>
  ),
};

// D2. 在投广告累计曝光量 Top10 渠道
export const adsChannelImpressionTips: TipsMapType = {
  en: (
    <>
      The sum of lifetime impressions for currently active ads, not the daily increment.
    </>
  ),
  zh: (
    <>
      在投广告投放至今累计曝光量的加总，非当日累计增量。
    </>
  ),
};

// 均值估算提示（KPI 卡片区域 ⓘ 图标）
export const adsAverageEstimateTips: TipsMapType = {
  en: (
    <>
      The data for the selected time period is based on average estimates (= daily cumulative value ÷ number of days). For precise data of this period, please contact sophiaxwxu@tencent.com
    </>
  ),
  zh: (
    <>
      当前所选时间段数据基于均值估算（= 日累计值 ÷ 天数）。如需该时段精确数据，请联系 sophiaxwxu@tencent.com
    </>
  ),
};

// 在投广告数 指标定义
export const adsActiveAdsTips: TipsMapType = {
  en: (
    <>
      Ad: Ads sharing the same creative, channel, advertiser, and device OS are merged into one entry. This metric counts the number of such merged ads currently in &quot;Active&quot; status.
    </>
  ),
  zh: (
    <>
      广告：对同时具有相同素材、渠道、广告主和设备系统的广告合并后，仍处于「投放中」状态的广告条数。
    </>
  ),
};

// 在投素材数 指标定义
export const adsActiveCreativesTips: TipsMapType = {
  en: (
    <>
      Creative: Ads with identical images/videos are deduplicated into a single creative. Images/videos with different resolutions, or videos with different durations, are treated as separate creatives.
    </>
  ),
  zh: (
    <>
      素材：相同的图片/视频的广告只保留一条作为素材。相同内容的图片/视频不同的分辨率、同一段视频不同的时长，被认为是不同的素材。
    </>
  ),
};

// 新增素材数 指标定义
export const adsNewCreativesTips: TipsMapType = {
  en: (
    <>
      Based on the creative deduplication logic, this counts creatives detected in active delivery for the first time on that day.
    </>
  ),
  zh: (
    <>
      基于素材去重逻辑，当日首次被监测到进入投放状态的素材数量。
    </>
  ),
};
